import { useSelector } from 'react-redux';
import { useEffect, useState } from 'preact/hooks';
import { recirculationVideoDataSelector } from '../../../common/store/selectors/recirculationVideoData.selector';
import { useStyles } from '../../../common/hooks/useStyles';
import { getStoriesSeekBarsStyleObject } from './storiesSeekBars.style';
import { StorySeekBar } from './storySeekBar/storySeekBar';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';

export const StoriesSeekBars = () => {
  const playerSize = useSelector(playerDataSelector.playerSize);
  const numberOfScenes = useSelector(recirculationVideoDataSelector.numberOfScenes);
  const endOfCurrentScene = useSelector(recirculationVideoDataSelector.endOfCurrentScene);
  const startOfCurrentScene = useSelector(recirculationVideoDataSelector.startOfCurrentScene);

  const [currentStoryDuration, setCurrentStoryDuration] = useState<number>(0);

  const styles = useStyles(getStoriesSeekBarsStyleObject, [playerSize]);
  const { storiesContainerStyle } = styles;

  useEffect(() => {
    setCurrentStoryDuration(endOfCurrentScene - startOfCurrentScene);
  }, [endOfCurrentScene, startOfCurrentScene, setCurrentStoryDuration]);

  return (
    <div style={storiesContainerStyle}>
      {Array.from({ length: numberOfScenes }, (_, index) => (
        <StorySeekBar index={index} currentStoryDuration={currentStoryDuration} />
      ))}
    </div>
  );
};
